





























































import { defineComponent, computed, ref, watch } from '~/utils/nuxt3-migration'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { useNamespacedStore } from '~/compositions/store'
import { useI18n } from '~/compositions/i18n'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { Searchable } from '~/models/search/types'

export default defineComponent({
  components: { CRadioButtonGroup, CSlider },
  props: facetHandlerComponentProps,
  setup(props) {
    const { state: classifiedSearchState } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const { changeParam, changeParams } = useClassifiedSearchFacet()
    const { t } = useI18n()

    const lowestSliderValue = computed(() =>
      props.searchables?.ranges?.length
        ? props.searchables.ranges.reduce(
            (min: number, s: Searchable) => Math.min(min, s.low as number),
            0
          )
        : props.searchables?.values?.reduce(
            (min: number, s: Searchable) =>
              Math.min(min, parseInt(s.v as string)),
            0
          )
    )

    const highestSliderValue = computed(() =>
      props.searchables?.ranges?.length
        ? props.searchables.ranges.reduce(
            (max: number, s: Searchable) => Math.max(max, s.low as number),
            0
          )
        : props.searchables?.values?.reduce(
            (max: number, s: Searchable) =>
              Math.max(max, parseInt(s.v as string)),
            0
          )
    )

    const selectedLow = ref(props.selected?.low || null)
    const selectedHigh = ref(props.selected?.high || null)
    const selectedRange = ref(
      props.humanParams.length ? props.humanParams[0].value : null
    )
    const selectedSliderRange = ref([
      props.selected?.low || lowestSliderValue.value,
      props.selected?.high || highestSliderValue.value
    ])

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const lowOptions = computed(() =>
      (props.searchables.values || props.searchables || []).map(s => ({
        label: s.n,
        value: s.v,
        disabled:
          selectedHigh.value !== null &&
          parseFloat(s.v) > parseFloat(selectedHigh.value)
      }))
    )

    const highOptions = computed(() =>
      (props.searchables.values || props.searchables || []).map(s => ({
        label: s.n,
        value: s.v,
        disabled:
          selectedLow.value !== null &&
          parseFloat(s.v) < parseFloat(selectedLow.value)
      }))
    )

    const rangesOptions = computed(() => [
      { label: t('all'), value: null },
      ...(props.searchables.ranges || []).map((s: Searchable) => ({
        label: `${s.low}/${s.high}`,
        value: s.v
      }))
    ])

    const sliderOptions = computed(() => {
      const options = props.searchables?.ranges?.length
        ? props.searchables.ranges.map((item: any) => ({
            label: item.low,
            value: item.low
          }))
        : (props.searchables?.values || []).map((s: Searchable) => ({
            label: s.n.toString(),
            value: parseInt(s.v as string)
          }))

      return [
        {
          label: '0',
          value: 0
        },
        ...options
      ]
    })

    const showOptionsAsButtonGroup = computed(() =>
      ['doors'].includes(props.name)
    )

    const showOptionsAsSlider = computed(() =>
      ['airbags', 'previous_owners'].includes(props.name)
    )

    watch(
      () => props.selected,
      (newSelected: any) => {
        selectedLow.value = newSelected.low || null
        selectedHigh.value = newSelected.high || null
        selectedRange.value = props.humanParams.length
          ? props.humanParams[0].value
          : null
        selectedSliderRange.value = [
          newSelected.low || lowestSliderValue.value,
          newSelected.high || highestSliderValue.value
        ]
      }
    )

    function onLowChange(value: number) {
      changeParam({
        name: `${props.urlArgNames[0]}-from`,
        value
      })
    }

    function onHighChange(value: number) {
      changeParam({
        name: `${props.urlArgNames[0]}-to`,
        value
      })
    }

    function onButtonGroupChange(value: string | null) {
      changeParam({
        name: props.urlArgNames[0],
        value
      })
    }

    function onSliderChange(value: number[]) {
      const [low, high] = value

      changeParams([
        {
          name: `${props.urlArgNames[0]}-from`,
          value: low
        },
        {
          name: `${props.urlArgNames[0]}-to`,
          value: high
        }
      ])
    }

    function onClear() {
      selectedLow.value = null
      selectedHigh.value = null
      selectedRange.value = null

      changeParams([
        {
          name: `${props.urlArgNames[0]}-from`,
          value: null
        },
        {
          name: `${props.urlArgNames[0]}-to`,
          value: null
        },
        {
          name: props.urlArgNames[0],
          value: null
        }
      ])
    }

    return {
      lowOptions,
      highOptions,
      selectedRange,
      selectedLow,
      selectedHigh,
      loadingFacets,
      showOptionsAsButtonGroup,
      rangesOptions,
      showOptionsAsSlider,
      sliderOptions,
      selectedSliderRange,
      onLowChange,
      onHighChange,
      onButtonGroupChange,
      onSliderChange,
      onClear
    }
  }
})
